import _implicitStylesheets from "./level2FilterSection.css";
import _implicitScopedStylesheets from "./level2FilterSection.scoped.css?scoped=true";
import _searchLevel2FilterOption from "search/level2FilterOption";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "small"
  },
  key: 0
};
const stc1 = {
  attrs: {
    "grid": "",
    "axis": "column",
    "row-gap": "small"
  },
  key: 1
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {k: api_key, b: api_bind, c: api_custom_element, i: api_iterator, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", stc0, [api_element("div", stc1, api_iterator($cmp.options, function (item) {
    return api_custom_element("search-level2-filter-option", _searchLevel2FilterOption, {
      props: {
        "l2option": item,
        "multiple": $cmp.multiple,
        "selectedValue": $cmp.selectedValue
      },
      key: api_key(2, item.value),
      on: {
        "change": _m0 || ($ctx._m0 = api_bind($cmp.handleChange))
      }
    });
  }))])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-2cgq8rojtf0";
tmpl.legacyStylesheetToken = "undefined-_level2FilterSection";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
